module.exports = __webpack_public_path__ + "img/014.8a3abb56.png";